<script>
import { inject, onBeforeUnmount, watch, computed, ref, toRefs } from 'vue';

export default {
  compatConfig: {
    ATTR_FALSE_VALUE: false,
  },

  props: {
    name: {
      type: String,
      required: true,
    },
    value: {
      type: [String, Array],
      default: '',
    },
  },

  emits: ['update:value'],

  setup(props, { emit }) {
    const { value } = toRefs(props);
    const getFieldValue = inject('form/getFieldValue', () => {});
    const storeFieldValue = inject('form/storeFieldValue', () => {});
    const deleteField = inject('form/deleteField', () => {});
    const fieldValue = computed({
      get: () => getFieldValue(props.name) || value.value,
      set: value => storeFieldValue(props.name, value),
    });

    watch(
      value,
      value => {
        fieldValue.value = value;
      },
      { deep: true }
    );

    watch(
      fieldValue,
      value => {
        emit('update:value', value);
        fieldValue.value = value;
      },
      { immediate: true, deep: true }
    );

    onBeforeUnmount(() => {
      deleteField(props.name);
    });

    return { storeFieldValue, fieldValue };
  },

  render() {
    // Without using a wrapper component, we can only render one child component.
    try {
      return this.$slots.default[0];
    } catch (e) {
      throw new Error(
        'BpbFormCommunicator can only render one, and exactly one child component.'
      );
    }

    return null;
  },
};
</script>
